export default {
    ACUPUNTURA_COM_INSERCAO_DE_AGULHAS: 1,
    ADMINISTRACAO_DE_VITAMINA_A: 2,
    CATETERISMO_VESICAL_DE_ALIVIO: 3,
    CAUTERIZACAO_QUIMICA_DE_PEQUENAS_LESOES: 4,
    CIRURGIA_DE_UNHA_CANTOPLASTIA: 5,
    COLETA_DE_CITOPATOLOGICO_DE_COLO_UTERINO: 6,
    CUIDADO_DE_ESTOMAS: 7,
    CURATIVO_ESPECIAL: 8,
    CURATIVO_SIMPLES: 9,
    DRENAGEM_DE_ABSCESSO: 10,
    ELETROCARDIOGRAMA: 11,
    EXAME_DO_PE_DIABETICO: 12,
    EXERESE_BIOPSIA_PUNCAO_DE_TUMORES_SUPERFICIAIS_DE_PELE: 13,
    FUNDOSCOPIA_EXAME_DE_FUNDO_DE_OLHO: 14,
    INFILTRACAO_EM_CAVIDADE_SINOVIAL: 15,
    REMOCAO_DE_CORPO_ESTRANHO_DA_CAVIDADE_AUDITIVA_E_NASAL: 16,
    REMOCAO_DE_CORPO_ESTRANHO_SUBCUTANEO: 17,
    RETIRADA_DE_CERUME: 18,
    RETIRADA_DE_PONTOS_DE_CIRURGIAS: 19,
    SUTURA_SIMPLES: 20,
    TAMPONAMENTO_DE_EPISTAXE: 21,
    TRIAGEM_OFTALMOLOGICA: 22,
    ORIENTACAO_INDIVIDUAL_EM_SAUDE: 23
}